import { DriverV2 } from "../../../models";
import { getVehicleLocation } from "./getVehicle";

export const getDriverNew = (data: any): DriverV2 => {
  return {
    id: data.id,
    userId: data.user_id,
    email: data.email,
    name: data.name,
    phoneNumber: data.phone_number,
    address: data.address,
    zip: data.zip,
    city: data.city || "",
    dlExpiration: data.dl_expiration,
    dotPhysicalExpiration: data.dot_physical_expiration,
    startTime: data.start_time,
    location: getVehicleLocation(data.location),
  };
};

export const getDriversNew = (data: any[]): DriverV2[] => {
  return data.map(getDriverNew);
};
